import React from "react";
import styled from "styled-components";

import { CleaningProduct } from "@typings/booking";

import { rem } from "@ui/helpers";

import { formatAmount } from "@services/FormatAmount";

interface Props extends CleaningProduct {
  isSpecialPricePlanSelected: boolean;
  oneTimeLabelText: string;
  removeCurrency?: boolean;
}

export const CleaningProductSummaryElement = (
  props: Props,
): React.ReactElement => {
  return (
    <Product>
      <ProductImage>
        <img src={props.imageUrl} alt={props.name} />
      </ProductImage>

      <ProductName>{props.name}</ProductName>

      <ProductPriceWrapper>
        <strong>
          {formatAmount(
            props.removeCurrency ? "" : props.currency,
            props.isSpecialPricePlanSelected && props.specialPrice !== null
              ? props.specialPrice
              : props.regularPrice,
          )}
        </strong>
        <ProductCaption>/{props.oneTimeLabelText}</ProductCaption>
      </ProductPriceWrapper>
    </Product>
  );
};

const Product = styled.li`
  display: flex;
  align-items: center;
`;

const ProductImage = styled.div`
  flex: 0 0 ${rem(32)};

  img {
    max-width: 100%;
  }
`;

const ProductName = styled.div`
  padding: 0 ${props => props.theme.margins.base_x2};
  flex: 1 1 auto;
`;

const ProductPriceWrapper = styled.div`
  text-align: right;
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
`;

const ProductCaption = styled.span`
  font-size: ${props => props.theme.fonts.sizes.caption};
  line-height: ${props => props.theme.fonts.lineHeights.caption};
`;
